import React, { Component } from "react";
import PropTypes from "prop-types";
import * as _ from "lodash-es";
import { FormattedNumber } from "react-intl";
import { Link } from "react-router-dom";
import ICommissionOrderDetail from "../../../../../models/ICommissionOrderDetail";
import { NumericFormat } from "react-number-format";

type Props = {
    vendorDetail: ICommissionOrderDetail;
};

type State = {
    ordersViewVisible: boolean;
};

class CommissionReportVendorRow extends Component<Props, State> {
    readonly state: State = {
        ordersViewVisible: false,
    };

    toggleOrdersView = () => {
        this.setState({
            ordersViewVisible: !this.state.ordersViewVisible,
        });
    };

    render() {
        return (
            <div className="CommissionReportVendorRow d-flex flex-column mb-2">
                <div className={"d-flex"}>
                    <span className={"me-auto pointer"} onClick={this.toggleOrdersView}>
                        <span className={"me-2 ms-4"}>
                            <i className={"fas " + (this.state.ordersViewVisible ? "fa-chevron-down" : "fa-chevron-up")}></i>
                        </span>
                        <span>{this.props.vendorDetail.name}</span>
                    </span>
                    <span>
                        <FormattedNumber value={Number(this.props.vendorDetail.grandTotal)} minimumFractionDigits={2} />
                    </span>
                </div>
                {this.state.ordersViewVisible
                    ? _.map(this.props.vendorDetail.orders, (order, index: number) => {
                          return (
                              <div className={"d-flex ms-5 border-secondary border-bottom"} key={index}>
                                  <span className={"me-auto"}>
                                      <Link to={`/orders/${order.guid}/entry`}>{order.name}</Link>
                                  </span>
                                  <span className={"me-5"}>
                                      <NumericFormat
                                          value={order.orderSubTotal}
                                          fixedDecimalScale={true}
                                          decimalScale={2}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                      />
                                  </span>
                                  <span className={"w-10 text-end"}>
                                      <NumericFormat
                                          value={order.commission}
                                          fixedDecimalScale={true}
                                          decimalScale={2}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                      />
                                  </span>
                              </div>
                          );
                      })
                    : null}
            </div>
        );
    }
}

export default CommissionReportVendorRow;
